// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__aohkh","LocationTag":"Tag_LocationTag__3o8qt","WhoTag":"Tag_WhoTag__3zW3p","WhatTag":"Tag_WhatTag__3YWQC"};